"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _ImageLightbox = require("@insided/shared/components/ImageLightbox");

var _fileTypeIcons = require("./fileTypeIcons");

var _FileAttachmentTile = _interopRequireDefault(require("./FileAttachmentTile"));

var Attachments = function Attachments(_ref) {
  var attachments = _ref.attachments,
      attachmentCdn = _ref.attachmentCdn;
  var attachmentsPerRow = 4;
  var gridClass = "grid--".concat(12 / attachmentsPerRow);

  var groupedAttachmentArray = function groupedAttachmentArray(array, size) {
    var result = [];

    for (var i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }

    return result;
  };

  var attachmentGroups = groupedAttachmentArray(attachments, attachmentsPerRow);

  var getBgImageUrlForImage = function getBgImageUrlForImage(attachment, attachmentCdn) {
    var bgImageUrl = attachment.source_thumb ? attachment.source_thumb : attachment.source;
    var isFullUrl = bgImageUrl.startsWith('http');
    return isFullUrl ? bgImageUrl : attachmentCdn + bgImageUrl;
  };

  function renderAttachment(attachment, attachmentCdn) {
    var isImage = attachment.type === 'image' || attachment.type === 'video';
    var mfpClass = isImage ? "mfp-".concat(attachment.type) : 'file-attachment';
    var bgImageUrl = isImage ? getBgImageUrlForImage(attachment, attachmentCdn) : undefined;
    var hrefImageLink = attachment.source.startsWith('http') ? attachment.source : "".concat(attachmentCdn).concat(attachment.source); // Get filename from either file_original_name or filename field

    var filename = attachment.file_original_name || attachment.filename || 'Unknown file';
    var FileTypeIcon = (0, _fileTypeIcons.getFileTypeIcon)(attachment.type);

    if (isImage) {
      return (0, _preact.h)("div", {
        className: "group__item ".concat(gridClass, " attachment__item"),
        key: "".concat(attachment.source, "-").concat(filename)
      }, (0, _preact.h)("a", {
        className: "attachment__link attachment__link--".concat(attachment.type, " ").concat(mfpClass),
        style: bgImageUrl ? {
          backgroundImage: "url(".concat(bgImageUrl, ")")
        } : undefined,
        href: (0, _absoluteUrlRuntime.resolveUrl)(hrefImageLink),
        target: "_blank",
        rel: "noreferrer"
      }, attachment.type === 'video' && (0, _preact.h)("span", {
        className: "icon icon--play"
      })));
    }

    return (0, _preact.h)("div", {
      className: "group__item ".concat(gridClass, " attachment__item"),
      key: "".concat(attachment.source, "-").concat(filename)
    }, (0, _preact.h)(_FileAttachmentTile.default, {
      href: (0, _absoluteUrlRuntime.resolveUrl)(attachment.source),
      filename: filename,
      type: attachment.type,
      FileTypeIcon: FileTypeIcon
    }));
  }

  return (0, _preact.h)("div", {
    className: "group attachments"
  }, (0, _preact.h)("h5", null, (0, _preact.h)("strong", null, (0, _preact.h)(_phrase.default, {
    p: "attachments.count",
    m: "Forum",
    count: {
      n: attachments.length.toString()
    },
    renderAsText: true
  }))), (0, _preact.h)("div", {
    ref: function ref(el) {
      if (el) _ImageLightbox.ImageLightbox.bindTo(el, 'a.attachment__link--image');
    }
  }, attachmentGroups.map(function (group) {
    return (0, _preact.h)("div", {
      key: "group-".concat(group[0].source, "-").concat(group[0].file_original_name || group[0].filename || 'unknown'),
      className: "group__row"
    }, group.map(function (attachment) {
      return renderAttachment(attachment, attachmentCdn);
    }));
  })));
};

var _default = Attachments;
exports.default = _default;